
const setProgressBar = ( progress, value, delay = 0 ) => {
    const progressBar = progress.firstElementChild;
    if ( progressBar?.classList.contains( 'progress-bar' ) ) {
        if ( delay === 0 ) {
            progressBar.style.width = value + "%";
        } else {
            window.setTimeout( () => {
                progressBar.style.width = value + "%";
            }, delay );
        }
    }
};

const setPublishedProductsIndicator = ( selector ) => {
    const progress = document.querySelector( selector );
    if ( progress ) {
        const value = progress.dataset.value;
        setProgressBar( progress, value, 500 );
        progress.style.height = '3px';
    }
};

export { setProgressBar, setPublishedProductsIndicator };